import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Product } from '../../../../../../../../../models/interface/product/product';
import { Cfs } from '../../../../../../../../../models/interface/product/cfs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { iif, of, Subscription } from 'rxjs';
import { CtoResponse, FtthService, QueryCtoResponse } from '../../../../../../../../../services/api/ftth/ftth.service';
import { catchError, map, pluck } from 'rxjs/operators';
import { LoaderService } from '../../../../../../../../../core/header-menu/loader/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductDepthLevelCfsActionsComponent } from '../product-depth-level-cfs-actions.component';
@Component({
  selector: 'app-update-fsan',
  templateUrl: './update-fsan.component.html',
  styleUrls: ['./update-fsan.component.scss']
})
export class UpdateFsanComponent implements OnInit, OnDestroy {

  updateFsanGroup: FormGroup;

  ctos: CtoResponse[] = [];
  displayedColumns: string[] = ['codigoCto', 'codigoSp1', 'codigoSp2', 'estadoPuerto', 'puertoCto', 'puertoSp2', 'actions'];

  loading: boolean;

  private item: Product;
  private subscriptions = new Subscription();

  constructor(
    private ftthService: FtthService,
    private loaderService: LoaderService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ProductDepthLevelCfsActionsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      item: Product;
      serviceId: number;
      type: string;
      fsan: string;
    },
  ) {
  }

  ngOnInit() {
    this.item = this.data.item;

    if (this.data.type !== 'cfs') {
      throw new Error('It must be a CFS');
    }

    this.subscriptions.add(this.loaderService.loading$.subscribe(loading => this.loading = loading));

    this.initForm();
    this.initFormValues();
  }

  private initForm(): void {
    this.updateFsanGroup = this.formBuilder.group({
      fsanCodeNew: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
      fsanCode: this.formBuilder.control({ value: '', disabled: true }, Validators.required),
      serviceId: this.formBuilder.control({ value: '', disabled: true }, Validators.required),
    });
  }

  private initFormValues(): void {
    this.serviceIdControl.setValue(this.data.serviceId)
    this.fsanCodeControl.setValue(this.data.fsan)
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }



  updateFSAN(): void {
    if (this.updateFsanGroup.valid) {
      let territoryUser: string = this.item.productCharValues.find(productCharValue => productCharValue.specId === 'pc_ftth_territory_user').value;
      this.subscriptions.add(this.ftthService
        .updateFSAN(
          this.fsanCodeNewControl.value,
          this.serviceIdControl.value,
          territoryUser
        )
        .subscribe(
          () => {
            this.dialogRef.close(true);
            this.notificationsService.showNotification(this.translateService.instant('UPDATE_FSAN.success'), NotificationLevel.SUCCESS);
          },
          error => {
            this.notificationsService.showNotification(this.translateService.instant('UPDATE_FSAN.error'), NotificationLevel.ERROR);
          }));
    }
  }



  get serviceIdControl(): FormControl {
    return this.updateFsanGroup.get('serviceId') as FormControl;
  }

  get fsanCodeNewControl(): FormControl {
    return this.updateFsanGroup.get('fsanCodeNew') as FormControl;
  }

  get fsanCodeControl(): FormControl {
    return this.updateFsanGroup.get('fsanCode') as FormControl;
  }

}
